import {
  IItemCommercialTranslation,
  IItemCommercialTranslationData,
  IItemCommercialTranslationFieldError,
  IItemCommercialTranslationFieldErrorData,
  ITEM_COMMERCIAL_TRANSLATION_LANGUAGE_CODE_LENGTH,
  ITEM_COMMERCIAL_TRANSLATION_MAX_FIELD_NAME_LENGTH,
  ITEM_COMMERCIAL_TRANSLATION_MAX_IDENTIFIER_LENGTH,
  ITEM_COMMERCIAL_TRANSLATION_MAX_LANGUAGE_DESCRIPTION_LENGTH,
  ITEM_COMMERCIAL_TRANSLATION_MAX_LANGUAGE_LENGTH
} from './itemcommercialtranslation.types';

export class ItemCommercialTranslation implements IItemCommercialTranslation {
  readonly id?: number;
  readonly field_name: string = 'description';
  readonly language: string = '';
  readonly text: string = '';
  readonly identifier: string = '';
  readonly language_code: string = '';
  readonly language_description: string = '';

  readonly manually_created: boolean = false;

  constructor(data?: IItemCommercialTranslationData) {
    if (data) {
      if (data.id) {
        this.id = data.id;
      }
      if (data.field_name) {
        this.field_name = data.field_name;
      }
      if (data.language) {
        this.language = data.language;
      }
      if (data.text) {
        this.text = data.text;
      }
      if (data.identifier) {
        this.identifier = data.identifier;
      }
      if (data.language_code) {
        this.language_code = data.language_code;
      }
      if (data.language_description) {
        this.language_description = data.language_description;
      }

      if (data.manually_created) {
        this.manually_created = data.manually_created;
      }
    }
  }

  validate(): boolean {
    if (
      !this.field_name ||
      this.field_name.length > ITEM_COMMERCIAL_TRANSLATION_MAX_FIELD_NAME_LENGTH
    ) {
      return false;
    }
    if (
      !this.language ||
      this.language.length > ITEM_COMMERCIAL_TRANSLATION_MAX_LANGUAGE_LENGTH
    ) {
      return false;
    }
    if (
      !this.language_code ||
      this.language_code.length !==
        ITEM_COMMERCIAL_TRANSLATION_LANGUAGE_CODE_LENGTH
    ) {
      return false;
    }
    if (
      !this.identifier ||
      this.identifier.length > ITEM_COMMERCIAL_TRANSLATION_MAX_IDENTIFIER_LENGTH
    ) {
      return false;
    }
    if (
      !this.language_description ||
      this.language_description.length >
        ITEM_COMMERCIAL_TRANSLATION_MAX_LANGUAGE_DESCRIPTION_LENGTH
    ) {
      return false;
    }
    if (!this.text) {
      return false;
    }
    return true;
  }
}

export class ItemCommercialTranslationFieldError
  implements IItemCommercialTranslationFieldError {
  readonly id: string[] = [];
  readonly field_name: string[] = []; //'description';
  readonly language: string[] = [];
  readonly text: string[] = [];
  readonly identifier: string[] = [];
  readonly language_code: string[] = [];
  readonly language_description: string[] = [];

  constructor(data?: IItemCommercialTranslationFieldErrorData) {
    if (data) {
      if (data.id) {
        this.id = data.id;
      }
      if (data.field_name) {
        this.field_name = data.field_name;
      }
      if (data.language) {
        this.language = data.language;
      }
      if (data.text) {
        this.text = data.text;
      }
      if (data.identifier) {
        this.identifier = data.identifier;
      }
      if (data.language_code) {
        this.language_code = data.language_code;
      }
      if (data.language_description) {
        this.language_description = data.language_description;
      }
    }
  }

  clearErrors(): void {
    this.id.length = 0;
    this.field_name.length = 0;
    this.language.length = 0;
    this.text.length = 0;
    this.identifier.length = 0;
    this.language_code.length = 0;
    this.language_description.length = 0;
  }

  static isItemCommercialTranslationFieldError(
    data: IItemCommercialTranslationFieldErrorData
  ): boolean {
    if (data.id && Array.isArray(data.id)) {
      return true;
    }
    if (data.field_name && Array.isArray(data.field_name)) {
      return true;
    }
    if (data.text && Array.isArray(data.text)) {
      return true;
    }
    if (data.language && Array.isArray(data.language)) {
      return true;
    }
    if (data.language_code && Array.isArray(data.language_code)) {
      return true;
    }
    if (data.identifier && Array.isArray(data.identifier)) {
      return true;
    }
    if (data.language_description && Array.isArray(data.language_description)) {
      return true;
    }
    return false;
  }
}
